module.exports = __webpack_public_path__ + "img/megaphone.d44587e6.svg";